export const SERVICE = 'service';
export const PLATFORM = 'platform';
export const INDUSTRY = 'industry';
